import React, {useState , useEffect} from 'react';

// Steps Components 
import Start from './steps/start';
import QuestionsPreliminaires from './steps/questions-preliminaires';
import Demandeur from './steps/demandeur';
import Conjoint from './steps/conjoint';
import Enfants from './steps/enfants';
import Logement from './steps/logement';
import Ressources from './steps/ressources';
import Pension from './steps/pension';
import Resultats from './steps/resultats';
import QuestionRessourcesEnfants from './steps/questions-ressources-enfants';
import sendReport from './components/sendReport';

// Utility Components.
// import Recapitulation from './components/recapitulation';

//Images

//Styles
import './styles/App.css';
import './sim-form.css';
import PositiveResult from './components/positive-result';
import NegativeResult from './components/negative-result';
import "iframe-resizer/js/iframeResizer.contentWindow"; // add this

function App() {

  const [step , setStep] = useState(0);
  const [data ,setData] = useState({
    setStep : setStep
  });
  const [display , setDisplay] = useState(<Start setStep={setStep}/>);


  const nextStep = () => {
    setStep(step+1);

    //scroll to the wrapper of the form
    const element = document.getElementById("wrapper");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  
  }
  //const nextStep = () => ( setStep(step+1) );

  const ressNextStep = (listeEnfantsAyantRessources)=> {
    
    if (data.enfants && ( data.enfants.hasEnfant ||  data.enfants.hasEnfantGardeAlternee )){
      let enfantHasRessources;
      if (typeof listeEnfantsAyantRessources == 'object') {
        enfantHasRessources = listeEnfantsAyantRessources.length > 0 ;
      }

      if ( enfantHasRessources === undefined) {
        // Ask if enfantHasRessources.
        let listeEnfants = [];
        let nombreEnfantFoyer = data.enfants.nombreEnfant ;

        if (data.enfants.hasEnfantGardeAlternee) {
          nombreEnfantFoyer += data.enfants.nombreEnfantGardeAlternee;
        }

        for ( let i =1 ;  i <= nombreEnfantFoyer ; i++ ) {
          listeEnfants.push(`enfant_${i}`);
        }
        
        setDisplay(<QuestionRessourcesEnfants
          enfants={listeEnfants}
          setStep={setStep}
          updateData={updateSimulationData}
          nextStep={ressNextStep}
          restart={restart}
          simulationData={data}
          step={step}
        />);
        return false; 
      }

      else if ( enfantHasRessources) {
        // Ask ressources .
        setDisplay(<Ressources
          individus={listeEnfantsAyantRessources}
          nextStep={nextStep}
          setStep={setStep}
          updateData= {updateData}
          restart={restart}
          simulationData={data}
          step={step}
        />);
        return false; 
      }

      else if ( !enfantHasRessources ) {
        console.log('next step directly')
        nextStep();
        return true;
      }      
    }

    nextStep();
    return true;

  }

  const restart  = () => {
    setData({
      setStep:setStep
    });
    setStep(0);
  };

  const updateSimulationData = async (dataName , value) => {
    if (!data.hasOwnProperty(dataName)){
      return addData(dataName,value);
    }else {
      return updateData(dataName,value);
    }
  }

  const addData = async (dataName , value)=>{
    return setData((prevData) => {
      let newData = {};
      newData[dataName] = value;

      return (
        {
          ...prevData,
          ...newData
        }
      );
    })
  };

  const updateData = async (dataName ,value)=>{
    return setData((prevData) => {
      prevData[dataName] = { ...prevData[dataName], ...value };
      return prevData;
    });
  }

  const testPreliminaires = ()=> {
    if ( [
      data.assuranceMaladieResidantFr ,
      data.assuranceMaladieResidantFr ,
      data.etudiantFNAU,
      data.beneficeRsa
    ].includes(undefined) ) {
      return null
    }

    if (data.assuranceMaladieActivitePro || data.assuranceMaladieResidantFr) {
      if (data.beneficeRsa || data.etudiantFNAU) {
        //positive result
        return true;
      } else {
        // next step
        return null;
      }
    } else {
      // go to negative result
      return false
    }
  }

  useEffect(()=>{
    if (step === 0 ){
      setDisplay( <Start id={"start"} nextStep={nextStep}/>);
    } 
    else if (step === 1 ){

      //start report

      sendReport();
      setDisplay( <QuestionsPreliminaires 
        nextStep={nextStep} 
        setData={setData}
        restart={restart}
        simulationData={data}
        step ={step}
      /> );
    }
    else if (step === 2 ){
      //setDisplay( <Demandeur nextStep={nextStep} updateData= {updateSimulationData}/>);
      let filter =  testPreliminaires();
      if (filter === null){
        setDisplay( <Demandeur
          nextStep={nextStep}
          updateData={updateSimulationData}
          restart={restart}
          simulationData={data}
          step ={step}
        /> );
      } else if (filter === true){
        // valider
        const droit = {
          definition_period: "2023-12",
          entity: "famille",
          imgSrc: "logo_assurance_maladie.png",
          label: "Complémentaire santé solidaire",
          link: "http:/www.aide-sociale.fr/complementaire-sante-solidaire/",
          nom: "cmu_c",
          type: "boolean",
          value: true
        };

        setDisplay(<div class="sim-form" id="resultats">
          <PositiveResult droit={droit} restart={restart}></PositiveResult>
        </div>);

      } else if (filter === false){
        // refuser
        setDisplay(<div className='sim-form min-height' id="resultats">
          <NegativeResult restart={restart}></NegativeResult>
        </div>)
      }

    }
    else if (step === 3 ){
      setDisplay(<Conjoint
        nextStep={nextStep}
        setStep={setStep}
        updateData={updateSimulationData}
        restart={restart}
        simulationData={data}
        step ={step}
      />);
    }
    else if (step === 4){
      setDisplay(<Enfants
        nextStep={nextStep}
        setStep={setStep}
        updateData={updateSimulationData}
        restart={restart}
        simulationData={data}
        step ={step}
      />);
    }
    else if (step === 5){
      setDisplay(<Logement
        nextStep={nextStep}
        setStep={setStep}
        updateData= {updateSimulationData}
        restart={restart}
        simulationData={data}
        step ={step}
      />);
    }
    else if (step === 6){
      let listeIndividus = ['demandeur'];
      
      if ( data.demandeur && data.demandeur.enCouple ) {
        listeIndividus.push('conjoint');
      }

      setDisplay(<Ressources
        individus={listeIndividus}
        setStep={setStep}
        nextStep={ressNextStep}
        updateData= {updateData}
        restart={restart}
        simulationData={data}
        step ={step}
      />);

    }
    else if (step === 7){
      setDisplay(<Pension
        nextStep={nextStep}
        setStep={setStep}
        updateData= {updateData}
        restart={restart}
        simulationData={data}
        step={step}
      />);
    }
    else if (step === 8){
      setDisplay(<Resultats 
        simulationData={data} restart={restart}></Resultats>);
    }
    
  } , [step]);
  const debug=false;
  if (debug) {
    return (
      <>
        <div style={{position: "fixed" , right:"0" , top:"0"}}>
          <input style={{border:"1px solid"}} type="number" className="form-control" onChange={(e)=>{ setStep(parseInt(e.target.value))}}/>
        </div>
        <div className="wrapper" id="wrapper">
          {display}
        </div>
      </>
    ); 
  }
  else {
    return (
      <div className="wrapper" id="wrapper">
        {display}
      </div>

    );
  }
}

export default App;
